import { api_get, api_put, PROYECT } from "services/api";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import { supportExpensesTypes } from "redux/reducers/supportExpenses/types";
import { monthsDictionary } from "helpers/dictionary";

const {
  HANDLE_SUPPORT_EXPENSES_INPUTS,
  GET_SUPPORT_EXPENSES,
  EDIT_PERIOD_EXPENSES,
} = supportExpensesTypes;

const mainUrl = `${process.env.REACT_APP_URL}${PROYECT}/expenses_periods`;

export const handleSupportExpensesInputsAction = (key, value) => async dispatch => {
  dispatch({ type: HANDLE_SUPPORT_EXPENSES_INPUTS, payload: { key, value } });
};

export const getSupportExpensesAction = (month, year, company) => async dispatch => {
  const monthSelect = monthsDictionary.find((value) => value?.id === month  )
  const url = `${mainUrl}/support?idCompany=${company}${month ? `&month=${monthSelect?.label}` : ''}${year ? `&year=${year}` : ''}`;
  dispatch(startRequestComp('loadingSupportExpenses'));
  try {
    const data = await api_get(url);
    dispatch({ type: GET_SUPPORT_EXPENSES, payload: data });
    dispatch(stopRequestComp('loadingSupportExpenses'));
  } catch (error) {
    dispatch(setSnackbar(error));
    dispatch(stopRequestComp('loadingSupportExpenses'));
  }
};


export const openPeriodExpenses = (id, form) => async dispatch => {
  const url = `${mainUrl}/${id}/open`;
  dispatch(startRequestComp('loadingModSupportExpenses'));
  try {
    const response = await api_put(url, form);
    dispatch({ type: EDIT_PERIOD_EXPENSES, payload: id });
    dispatch(setSnackbar(response?.message, 'success'));
    dispatch(stopRequestComp('loadingModSupportExpenses'));
  } catch (error) {
    dispatch(setSnackbar(error));
    dispatch(stopRequestComp('loadingModSupportExpenses'));
  }
};

export const closePeriodExpenses = (id, form) => async dispatch => {
  const url = `${mainUrl}/${id}/close`;
  dispatch(startRequestComp('loadingModSupportExpenses'));
  try {
    const response = await api_put(url, form);
    dispatch({ type: EDIT_PERIOD_EXPENSES, payload: id });
    dispatch(setSnackbar(response?.message, 'success'));
    dispatch(stopRequestComp('loadingModSupportExpenses'));
  } catch (error) {
    dispatch(setSnackbar(error));
    dispatch(stopRequestComp('loadingModSupportExpenses'));
  }
};
